<ion-grid class="bg-white rounded-lg p-20">
	<ion-row>
		<ion-col size="12" class="font-sans">
			<div class="font-sans text-2xl font-bold pb-16 text-center">
				Welcome back, Fellows
			</div>
			<ion-button
				class="font-sans text-xl h-50 google-sign-in normal-case pb-10"
				expand="full"
				(click)="signupUsingGoogle()"
			>
				<ion-icon name="logo-google" class="mr-16"></ion-icon>
				Sign In With Google
			</ion-button>

			<ion-button
				class="font-sans text-xl h-50 google-sign-in normal-case"
				expand="full"
				(click)="signupUsingLinkedin()"
			>
				<ion-icon name="logo-linkedin" class="mr-16"></ion-icon>
				Sign In With Linkedin
			</ion-button>

			<div class="my-24">
				<div class="seperator"></div>
				<div class="seperatorText">Or</div>
				<div class="seperator"></div>
			</div>

			<form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm)">
				<ion-item class="signupFormItem my-28 leading-6" lines="full">
					<ion-label position="floating">Email</ion-label>
					<ion-input formControlName="email" type="text"></ion-input>
				</ion-item>

				<ng-container *ngFor="let validation of loginFormErrorMessages.email">
					<div
						class="errorMessageClass flex items-center mb-12"
						*ngIf="
							loginForm.get('email')?.hasError(validation.type) &&
							(loginForm.get('email')?.dirty || loginForm.get('email')?.touched)
						"
					>
						<ion-icon name="close-circle" class="text-rose-600"></ion-icon>
						<span class="text-rose-600 ml-8 mt-2">{{
							validation.message
						}}</span>
					</div>
				</ng-container>

				<ion-item class="signupFormItem my-24 leading-6" lines="full">
					<ion-label position="floating">Password</ion-label>
					<ion-input formControlName="password" type="password"></ion-input>
				</ion-item>

				<ng-container
					*ngFor="let validation of loginFormErrorMessages.password"
				>
					<div
						class="errorMessageClass flex items-center mb-12"
						*ngIf="
							loginForm.get('password')?.hasError(validation.type) &&
							(loginForm.get('password')?.dirty ||
								loginForm.get('password')?.touched)
						"
					>
						<ion-icon name="close-circle" class="text-rose-600"></ion-icon>
						<span class="text-rose-600 ml-8 mt-2">{{
							validation.message
						}}</span>
					</div>
				</ng-container>

				<button
					ion-button
					class="yellowButton rounded-md h-50 text-xl w-full ion-activatable ripple-parent"
					type="submit"
				>
					Sign In
					<ion-spinner *ngIf="isLoading"></ion-spinner>

					<ion-ripple-effect></ion-ripple-effect>
				</button>
			</form>
			<ion-row>
				<ion-col class="mt-24">
					<div>
						<a
							class="text-blue-600 cursor-pointer text-lg no-underline"
							(click)="authService.redirectAuth('forgot-password')"
							>Forgot Password?</a
						>
					</div>
				</ion-col>
			</ion-row>
		</ion-col>
	</ion-row>
</ion-grid>

<ion-grid class="mt-24 bg-white height rounded-lg p-20">
	<ion-row class="font-sans text-2xl font-bold justify-center">
		Get the App
	</ion-row>
	<ion-row class="justify-center mt-16">
		<ion-col size="4" class="font-sans">
			<a
				href="https://play.google.com/store/apps/details?id=app.terra.hubbleBeta.prod"
				target="_blank"
			>
				<img src="../../../../assets/google_play.svg" />
			</a>
		</ion-col>
		<ion-col size="4" class="font-sans">
			<a
				href="https://apps.apple.com/us/app/terra-do/id1618165862"
				target="_blank"
			>
				<img src="../../../../assets/apple.svg" />
			</a>
		</ion-col>
	</ion-row>
</ion-grid>
